import React from 'react';

import './Teaser.scss';

class Teaser extends React.Component {
  constructor(props) {
    super(props);
    this.handleEmailChange = this.handleEmailChange.bind(this);

    this.state = {
      email: ''
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleEmailChange(event) {
    this.setState({
      email: event.target.value
    });
  }

  render() {
    return (
      <div className="teaser-wrapper">
        <div className="teaser">
          <div className="teaser__left">
            <div className="teaser__message">
              <p>
              Aloha50 brings people together over common concerns and stories that are expressed through art. Art is a universal language that has the power to change our perspective by reaching directly into our hearts. It may be challenging to relate to a charitable cause, but a painting of someone&apos;s personal story can start the conversation. We hope that Aloha50 will not only help bring awareness to the issues but also unite our communities.
              </p>
            </div>
            <div className="teaser__signup">
              <div id="mc_embed_signup">
                <form
                  action="//aloha50.us16.list-manage.com/subscribe/post?u=6e7b28b8debd0422272f747be&amp;id=cb887eaf12"
                  method="post"
                  id="mc-embedded-subscribe-form"
                  name="mc-embedded-subscribe-form"
                  className="validate form-horizontal"
                  target="_blank"
                  noValidate
                >
                  <p className="teaser__signup__message">Help us to inspire people to come together for a good cause! Sign up below to be notified of our launch!</p>
                  <div className="input-group">
                    <input type="email" value={this.state.email} onChange={this.handleEmailChange} name="EMAIL" placeholder="Email" className="form-control required email" id="mce-EMAIL" />
                    <div className="input-group-btn">
                      <input type="submit" value="Notify Me" name="subscribe" id="mc-embedded-subscribe" className="button btn btn-default" />
                    </div>
                  </div>
                  <div id="mce-responses" className="clear">
                    <div className="response" id="mce-error-response" style={{display:'none'}}></div>
                    <div className="response" id="mce-success-response" style={{display:'none'}}></div>
                  </div>
                  <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true"><input type="text" name="b_6e7b28b8debd0422272f747be_cb887eaf12" tabIndex="-1" value="" /></div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Teaser;



// WEBPACK FOOTER //
// ./src/components/pages/Teaser.jsx